import React, {FunctionComponent, useEffect} from 'react';
import 'antd/dist/antd.css';
import {Link, Route, useLocation, useNavigate} from 'react-router-dom';
import {Routes} from 'react-router';
import styled from 'styled-components';
import {get} from 'lodash';
import {Button} from 'primereact/button';
import classNames from 'classnames';
import {useAuth0} from '@auth0/auth0-react';
import {useLazyQuery} from '@apollo/react-hooks';
import ReactGA from 'react-ga4';

import Page from './shared/components/soft-farms-bootstrap';
import Home from './pages/home';
import Billing from './pages/Billing/Billing';
import Horeca from 'pages/Horeca/Horeca';
import HarvestList from 'pages/HarvestList/HarvestList';
import BasketsPage from './pages/BasketsPage/BasketsPage2';
import BasketsPageNew from './pages/BasketsPage/BasketsPage3';
import SelfHarvestPage from 'pages/SelfHarvestPage/SelfHarvestPage';
import CsaPage from 'pages/CsaPage/CsaPage';
import Shop from './pages/Shop/Shop';
import ShopInfo from './pages/Shop/ShopInfo';
import AccountPage from './pages/AccountPage/AccountPage';
import Potluck from './pages/Potluck/Potluck';
import GeneralConditionsPage from './pages/GeneralConditionsPage/GeneralConditionsPage';
import CampaignPage from 'pages/CampaignPage/CampaignPage';
import appConfig from './config.app';
import {CheckUser} from './__generated__/types';
import {CheckUserQuery} from './shared/queries.gql';
import ActiviteitenPage from "./pages/ActiviteitenPage/ActiviteitenPage";

type RouteMenu = {
  title: string;
};

type HeaderOptions = {
  height?: string;
  img?: string;
  mobileImg?: string;
};

type AppRoute = {
  path: string;
  component: React.ComponentType<any>;
  hidden?: boolean;
  feest?: boolean;
  showOpendeur?: boolean;
  menu?: RouteMenu;
  headerOptions?: HeaderOptions;
};

type AuthAction = (options?: any) => void;

type NavigationItem = {
  label: string;
  link?: string;
  url?: string;
  target?: string;
  icon?: string;
  className?: string;
};

const HORECA_CLIENT_GROUP_ID = 'ckbuxfzgg07x30774zagfq0x1';
const DETAILHANDEL_CLIENT_GROUP_ID = 'ckbuxfzgm07xb0774cbvd90sk';
const SIGNUP_URL = 'https://www.mijnboer.be/groentegeweld/inschrijven';

const createRoutes = (
  loginWithRedirect?: AuthAction,
  logout?: AuthAction,
): AppRoute[] => [
  {
    path: '/',
    component: Home,
    feest: false,
    menu: {
      title: 'Home',
    },
  },
  {
    path: '/voorwaarden',
    component: GeneralConditionsPage,
    hidden: true,
    menu: {
      title: 'Voorwaarden',
    },
  },
  {
    path: '/zelfoogst',
    component: SelfHarvestPage,
    feest: false,
    menu: {
      title: 'Zelfoogst',
    },
  },
  {
    path: '/activiteiten',
    component: ActiviteitenPage,
    feest: false,
    menu: {
      title: 'Activiteiten',
    },
  },
  {
    path: '/pakketten-oud',
    component: BasketsPage,
    feest: false,
    menu: {
      title: 'Pakketten',
    },
  },
  {
    path: '/pakketten',
    component: BasketsPageNew,
    hidden: true,
    feest: false,
    menu: {
      title: 'Pakketten',
    },
  },
  {
    path: '/csa',
    component: CsaPage,
    feest: false,
    menu: {
      title: 'CSA',
    },
  },
  {
    path: '/facturatie',
    component: Billing,
    hidden: true,
    menu: {
      title: 'Facturatie',
    },
  },
  {
    path: '/lekkerstebuurt',
    component: CampaignPage,
    hidden: true,
    menu: {
      title: 'Lekkerste buurt',
    },
  },
  {
    path: '/potluck',
    component: Potluck,
    hidden: true,
  },
  {
    path: '/horeca',
    hidden: true,
    feest: false,
    component: () => <Horeca clientGroup={HORECA_CLIENT_GROUP_ID}/>,
    menu: {
      title: 'Aanbod: horeca',
    },
  },
  {
    path: '/detailhandel',
    hidden: true,
    feest: false,
    component: () => <Horeca clientGroup={DETAILHANDEL_CLIENT_GROUP_ID}/>,
    menu: {
      title: 'Aanbod: detailhandel',
    },
  },
  {
    path: '/veldwinkel/bestellen',
    component: Shop,
    menu: {
      title: 'Veldwinkel',
    },
  },
  {
    path: '/veldwinkel',
    component: ShopInfo,
    feest: false,
    menu: {
      title: 'Veldwinkel info',
    },
    headerOptions: {
      height: '40',
      img: 'shop.jpeg',
    },
  },
  {
    path: '/oogstlijst',
    component: HarvestList,
    hidden: true,
  },
  {
    path: '/inschrijven',
    component: Home,
    hidden: true,
  },
  {
    path: '/account',
    component: AccountPage,
    hidden: true,
  },
  {
    path: '/login',
    hidden: true,
    component: () => (
      <div>
        <Button
          label="Aanmelden"
          onClick={() => loginWithRedirect?.({redirectUri: appConfig.redirectUrl})}
        />
        <Button
          label="Afmelden"
          onClick={() => logout?.({returnTo: window.location.origin})}
        />
      </div>
    ),
  },
];

const navigationItems: NavigationItem[] = [
  {
    label: 'Zelfoogst',
    link: '/zelfoogst',
  },
  {
    label: 'Pakketten',
    link: '/pakketten',
  },
  {
    label: 'Activiteiten',
    link: '/activiteiten',
  },
  {
    label: 'CSA',
    link: '/csa',
  },
  // {
  //   label: 'Word deelnemer',
  //   url: SIGNUP_URL,
  //   target: '_blank',
  //   className: 'highlight',
  // },
  {
    label: 'Online veldwinkel',
    // link: '/veldwinkel',
    link: 'https://www.mijnboer.be/groentegeweld/shop',
    target: '_blank',
    icon: 'pi pi-shopping-cart',
  },
];

export const Content = styled.div`
  padding: 1vh 4vw;

  @media only screen and (min-width: 1000px) {
    max-width: 1300px;
    margin: 0 auto;
  }
`;

export const FullImage = styled.div<{ img: string; height?: string }>`
  background-image: url(${({img}) => img});
  background-size: cover;
  background-position: center;
  height: ${({height}) => height || '50vh'};
  overflow: hidden;
`;

const NavigationWrapper = styled.div`
  background-color: white;
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #748f56;
  padding: 0.5rem 1rem;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 1rem;
  align-items: center;

  .navigation-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.35rem 0.75rem;
    min-width: 0;
  }

  @media only screen and (max-width: 960px) {
    grid-template-columns: 1fr auto;
    grid-template-areas:
      "logo user"
      "nav nav";
    gap: 0.35rem 0.75rem;
    padding: 0.35rem 0;

    .left-logo {
      grid-area: logo;
    }

    .navigation-links {
      grid-area: nav;
      justify-content: center;
      flex-wrap: wrap;
      overflow-x: auto;
      padding-bottom: 0.25rem;
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
    }

    .navigation-links::-webkit-scrollbar {
      display: none;
    }
    //
    //.centered-logo {
    //  display: none;
    //}
  }
  //
  //@media only screen and (min-width: 961px) {
  //  //.centered-logo {
  //  //  display: none;
  //  //}
  //
  //  .left-logo {
  //    display: block;
  //  }
  //}
`;

const NavigationLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.75rem;
  border-radius: 999px;
  color: #748f56;
  font-size: clamp(0.95rem, 1.2vw, 1.2rem);
  font-family: Montserrat, sans-serif;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    color: #ee7a31;
    background-color: var(--orange-10);
    text-decoration: none;
  }

  &.active {
    font-weight: bold;
    color: #ee7a31;
  }

  &.highlight {
    background-color: #ee7a31;
    color: white;
    font-weight: bold;
  }

  &.highlight:hover {
    background-color: white;
    color: var(--orange);
    box-shadow: inset 0 0 0 1px var(--orange);
  }

  @media only screen and (max-width: 960px) {
    padding: 0.45rem 0.65rem;
    font-size: 0.95rem;
  }
`;

const Logo = styled.img`
  width: 200px;

  @media only screen and (max-width: 960px) {
    width: 100px;
  }
`;

const ContentWrapper = styled.div`
  top: 110px;
  position: relative;

  @media only screen and (max-width: 960px) {
    top: 99px;
  }
`;

export const Parallax = styled.img<{ height?: string; minHeight?: string; img: string; mobileImg?: string }>`
  background-image: url(${({img}) => img});
  height: ${({height}) => height || '0'};
  background-size: cover;
  width: 100%;
  display: block;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;

  @media only screen and (max-device-width: 1366px) {
    background-attachment: scroll;
  }
`;

const WebsitePage = styled(Page)`
  font-family: Montserrat, sans-serif;

  p {
    font-size: 16px;
  }

  p a {
    font-weight: bold;
    color: var(--orange);
    text-decoration: underline;
  }
`;

const FeestBanner: FunctionComponent = () => (
  <a href="/feest" className="relative top-0 w-full bg-white flex justify-content-center">
    <img
      className="w-full"
      style={{maxWidth: '1200px'}}
      src="lekkerstefeest-banner.jpg"
      alt=""
    />
    <div className="absolute bottom-0">
      <div className="flex mb-2 md:mb-4">
        <a className="text-lg sm:text-xl lg:text-2xl font-bold color-orange" href="/feest">
          Meer info & inschrijvingen
        </a>
      </div>
    </div>
  </a>
);

const OpendeurBanner: FunctionComponent = () => (
  <Link to="/veldwinkel">
    <img
      src="contact-post.jpg"
      alt="Infodag zondag 7 mei"
      style={{
        maxWidth: '90vw',
        maxHeight: '40vh',
        position: 'absolute',
        left: '50%',
        top: '10vh',
        border: '3px solid var(--orange)',
        transform: 'translate(-50%, 0)',
        boxShadow: '5px 5px 15px 5px #000',
      }}
    />
  </Link>
);

const App: FunctionComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {user: authUser} = useAuth0();
  const [checkUser] = useLazyQuery<CheckUser>(CheckUserQuery);

  const pathname = location.pathname;
  const routes = createRoutes();

  const activeRoute = routes.find(route => route.path === pathname);
  const headerImg = get(activeRoute, 'headerOptions.img');
  const headerHeight = get(activeRoute, 'headerOptions.height', false);

  const menuModel = navigationItems.map(item => ({
    ...item,
    className: `${item.className || ''} ${classNames({active: pathname === item.link})}`.trim(),
  }));

  useEffect(() => {
    if (authUser) {
      checkUser({variables: {email: authUser.email}});
    }
  }, [authUser, checkUser]);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: pathname + location.search,
      title: activeRoute?.menu?.title,
    });
  }, [activeRoute?.menu?.title, location.search, pathname]);

  return (
    <WebsitePage id="page">
      <NavigationWrapper className="bg-white top-0 left-0 right-0 fixed">
        <div className="left-logo">
          <Link to="/">
            <Logo src="logo-10jaar.png" alt=""/>
          </Link>
        </div>

        <nav className="navigation-links" aria-label="Hoofdnavigatie">
          {menuModel.map(item => {
            const content = (
              <>
                {item.icon && <i className={item.icon} aria-hidden="true"/>}
                <span>{item.label}</span>
              </>
            );

            if (item.link) {
              return (
                <NavigationLink
                  as={Link}
                  key={item.label}
                  to={item.link}
                  className={item.className}
                >
                  {content}
                </NavigationLink>
              );
            }

            return (
              <NavigationLink
                key={item.label}
                href={item.url}
                target={item.target}
                rel={item.target === '_blank' ? 'noreferrer' : undefined}
                className={item.className}
              >
                {content}
              </NavigationLink>
            );
          })}
        </nav>

        <div className={'mr-1 flex gap-1 lg:flex-column'}>
          <Button
            label="Mijn abonnement"
            icon={'pi pi-user'}
            iconPos={'right'}
            className='p-button-outlined p-button p-1 px-2 white-space-nowrap text-xs'
            onClick={() => navigate('https://www.mijnboer.be/groentegeweld')}
          />
          <Button
            label={'Word deelnemer'}
            icon={'pi pi-external-link'}
            iconPos={'right'}
            className={'p-button bg-orange color-white p-1 px-2 white-space-nowrap text-xs'}
            onClick={() => window.open('https://www.mijnboer.be/groentegeweld/inschrijven', '_blank')}
          />
        </div>
      </NavigationWrapper>

      <ContentWrapper>
        <div className="relative">
          {headerImg && (
            <FullImage
              img={headerImg}
              height={`${headerHeight}vh`}
            />
          )}
        </div>

        <Routes>
          {routes.map(({component: Component, path}) => (
            <Route key={path} path={path} element={<Component/>}/>
          ))}
        </Routes>
      </ContentWrapper>
    </WebsitePage>
  );
};

const RoutedApp = () => <App/>;

export default RoutedApp;
